<template>
  <v-overlay id="ErrorDialog" :opacity="0.3" :value="is_error">
    <v-dialog v-model="is_error" persistent max-width="380">
      <v-card class="text-center mx-auto" flat rounded="xl">
        <v-card-title
          class="red--text text--darken-1 font-weight-bold justify-center"
        >
          {{ error_title ? error_title : "พบข้อผิดพลาด" }}
        </v-card-title>

        <v-divider />

        <v-card-text class="mt-4">
          <span class="font-weight-medium">
            {{ error_msg ? error_msg : "-" }}</span
          >
        </v-card-text>

        <v-divider />

        <v-card-actions class="justify-center">
          <v-btn
            rounded
            depressed
            color="primary"
            @click.prevent="hideErrorDialog()"
          >
            ยืนยัน
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-overlay>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: "ErrorDialog",
  computed: {
    ...mapState({
      is_error: (state) => state.is_error,
      error_msg: (state) => state.error_msg,
      error_title: (state) => state.error_title,
    }),
  },
  methods: {
    ...mapMutations({
      hideErrorDialog: "HIDE_ERROR_DIALOG",
    }),
  },
};
</script>

<style></style>
